<template>
    <div>
        <div class="form-group row original" style="padding-top:30px">
            <div class="col-md-2">
                <label>Amount</label>
                <h4>RS: {{ data.amount }}</h4>
            </div>

            <div class="col-md-3">
                <label>Cash </label>
                <h4>RS: {{ data.CashAmount }}</h4>
            </div>

            <div class="col-md-2">
                <label>Card </label>
                <h4>RS: {{ data.CardAmount }}</h4>
            </div>

            <div class="col-md-2">
                <label>Tickets</label>
                <h4>{{ data.tickets }}</h4>
            </div>

            <div class="col-md-2">
                <label>Cash Balance</label>
                <h4>RS: {{ data.CashBalanace }}</h4>
            </div>
        </div>

       


        <div class="form-group row" v-can="'Change Payment Type'">
             <!-- Change Ticket Payment type -->
             <div
                class="col-md-6 login-content"           
                style="display: block"
            >
                <!-- return_type -->
                    <div
                        class="input-div"                       
                    >
                        <div class="i">
                            <i
                                class="fas fa-clipboard-list"
                            ></i>
                        </div>
                        <div class="div">
                            <select
                                class=" input form-select"
                                aria-label="Default select example"                               
                                v-model="
                                    ChangePaymentTypObj
                                "
                                name="ChangePaymentType"
                                id="ChangePaymentType"                               
                               
                            >
                               
                                <option value="Cash Payment"
                                    >Cash Payment</option
                                >

                                <option value="Card Payment"
                                    >Card Payment</option
                                >                                
                                                           
                                          
                            </select>
                        </div>
                    </div>                   

                <!-- End return_type -->
            </div>


            <div
                class="col-md-4 login-content"           
                style="display: block"
            >                                 
                    <button
                        type="btn"
                        :class="btnClass"
                        id="PaymentTypeBtn"
                        :disabled="disabalePaymentTypeBtn"                    
                        @click="ChangePaymentType()"
                    >
                        Change Payment Type
                    </button>                    
            </div>
            <!-- End Change Ticket Payment type -->

        </div>

       
        
    </div>
</template>

<style scoped>
form {
    width: 100%;
}

p {
    font-size: 15px;
    margin: 0px;
}

.card-single {
    padding: 1rem;
    background-color: #e8daef;
}

th,
td {
    border: 1px solid black;
}

.original h2 h4,
label {
    color: #8e44ad;
    font-weight: bold;
}

.btn-invoice-background-err {
    background-color: #cb4335;
}

.btn-invoice-background-refund-start {
    background-color: #239b56;
}
</style>

<script>
import { required, numeric, decimal, helpers } from "vuelidate/lib/validators";
const quty = helpers.regex("nameVal", /^[1-9]\d*$/);
const q = helpers.regex("nameVal", /^(0|[1-9]\d*)$/);
const config = {
    headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
    },
};
let formData = new FormData();

export default {
   
    created() {
        console.log(this.invoice)
          this.data=this.invoice;
          this.ramount=this.refundQty,
          this.rqty=this.refundAmount,
          this.ChangePaymentTypObj=this.invoice.paymenttype
    },
    props: [
        "invoice",
        "refundQty",
        "refundAmount"       
    ],
    data() {
        return {   
            data:"",
            ramount:"",
            rqty:"",        
            errors: {},
            btnClass: "btn-small-width btn-invoice",
            ChangePaymentTypObj:"",         
            disabalePaymentTypeBtn:false,
            btnClass: "btn-small-width btn-invoice",
    
        };
    },

    validations: {    
         
    },

    methods: {
            
        ChangePaymentType() {          
          
            this.disabalePaymentTypeBtn = true;       

                formData.append("invoice_id", this.data.invoice_id);
                formData.append("payment_type", this.ChangePaymentTypObj);

                axios
                    .post("/cashier/invoice-payment-type", formData, config)
                    .then((response) => {
                        Toast.fire({
                                icon: "success",
                                title: "Payment Type Changed",
                            });
                    })
                    .catch((error) => {
                        this.disabalePaymentTypeBtn = false;                       

                        if (error.response.status == 422) {
                            this.errors = error.response.data.errors;
                        }else if (error.response.status == 500) {
                            Toast.fire({
                                icon: "error",
                                title: error.response.data.errors.message,
                            });
                        } else {
                            Toast.fire({
                                icon: "error",
                                title: error.response.data.errors.message,
                            });
                        }
                    });
        },        
    },
};
</script>
